<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col :cols="6">
          <h1 class="headline font-weight-light mb-3">Announce</h1>
        </v-col>
        <v-col :cols="6" class></v-col>
      </v-row>
    </v-container>


    <v-dialog v-model="dialog" max-width="1000px">
      <v-form method="post" id="Formannounce" v-model="validannounce">
        <v-card>
          <v-card-text>
            <v-container>
              <div id="app">
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="editedItem.type"
                      :items="type"
                      label="Type"
                      required
                      outlined
                      style="max-width:500px;"
                      dense
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <h2>Title</h2>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="editedItem.title"
                      outlined
                      :rules="nottitle"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" sm="6" md="3">
                    <v-switch
                      label="Active Status"
                      v-model="editedItem.status"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    v-if="editedItem.type == 'Announce'"
                  >
                    <v-select
                      v-model="teamselected"
                      item-text="team_name"
                      item-value="team_id"
                      :items="team"
                      label="Team"
                      required
                      outlined
                      multiple
                      style="max-width:500px;"
                      dense
                    >
                      <template
                        v-slot:selection="{
                          item,
                          index,
                        }"
                      >
                        <v-chip v-if="index < 2">
                          <span>{{ item.team_name }}</span>
                        </v-chip>
                        <span v-if="index === 2" class="grey--text caption">
                          (+{{ teamselected.length - 2 }}
                          others)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    v-if="editedItem.type == 'Announce'"
                  >
                    <v-select
                      v-model="editedItem.important"
                      item-text="name"
                      item-value="id"
                      :items="item1"
                      label="Important"
                      :rules="notimportant"
                      required
                      outlined
                      style="max-width:500px;"
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    v-if="editedItem.type == 'Announce'"
                  >
                    <v-menu
                      v-model="datemenu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="computedDateFormatted1"
                          label="Expired Date"
                          hint="MM/DD/YYYY format"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date1"
                        no-title
                        @input="datemenu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <h2 v-if="editedItem.type == 'Knowledge'">Keyword</h2>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    v-if="editedItem.type == 'Knowledge'"
                  >
                    <!-- <v-combobox
                      v-model="select"
                      :items="items"
                      label="I use chips"
                      multiple
                      chips
                    ></v-combobox> -->

                    <v-combobox
                      v-model="editedItem.keyword"
                      chips
                      clearable
                      label="คำที่ต้องการให้ค้นหา เช่น ชื่อเรื่อง ชื่อหมวดหมู่ ชื่อประเภท ฯลฯ"
                      multiple
                      solo
                    >
                      <template
                        v-slot:selection="{
                          item,
                          select,
                          selected,
                        }"
                      >
                        <v-chip
                          :input-value="selected"
                          close
                          small
                          @click="select"
                          @click:close="remove(item)"
                        >
                          <strong>{{ item }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>

                <h2>Subtitle</h2>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.subtitle"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <h2 class="mb-5">Content</h2>
                <vue-editor
                  id="editor2"
                  v-model="editedItem.content"
                ></vue-editor>

                <form>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <template>
                        <v-file-input
                          v-model="editedItem.files"
                          color="blue darken-4"
                          counter
                          multiple
                          label="Attach files (optional) / แนบไฟล์ (ถ้ามี)"
                          placeholder="Select your files"
                          prepend-icon="mdi-paperclip"
                          :show-size="1000"
                          @change="onFileSelected"
                        >
                          <template
                            v-slot:selection="{
                              index,
                              text,
                            }"
                          >
                            <v-chip
                              v-if="index < 2"
                              color="blue accent-4"
                              dark
                              label
                              small
                              >{{ text }}</v-chip
                            >

                            <span
                              v-else-if="index === 2"
                              class="overline grey--text text--darken-3 mx-2"
                            >
                              +{{ files.length - 2 }}
                              File(s)
                            </span>
                          </template>
                        </v-file-input>
                      </template>
                    </v-col>
                  </v-row>
                </form>

                <v-row>
                  <v-col>
                    <v-chip
                      v-for="(itemeditpic, idxeditpic) in edit.files"
                      :key="idxeditpic"
                      close
                      @click:close="
                        deletepic(
                          itemeditpic.file_store_name,
                          edit,
                          itemeditpic
                        )
                      "
                      small
                      class="mr-2 mb-2"
                      :href="
                        showpic +
                          itemeditpic.file_store_name +
                          '/' +
                          itemeditpic.file_name
                      "
                      target="_blank"
                    >
                      <v-avatar left>
                        <v-icon small>mdi-paperclip</v-icon>
                      </v-avatar>
                      {{ itemeditpic.file_name }}
                    </v-chip>
                    <v-chip
                      v-for="(itemeditpic, idxeditpic) in edit.images"
                      :key="idxeditpic"
                      close
                      @click:close="
                        deletepic(
                          itemeditpic.file_store_name,
                          edit,
                          itemeditpic
                        )
                      "
                      small
                      class="mr-2 mb-2"
                      :href="
                        showpic +
                          itemeditpic.file_store_name +
                          '/' +
                          itemeditpic.file_name
                      "
                      target="_blank"
                    >
                      <v-avatar left>
                        <v-icon small>mdi-paperclip</v-icon>
                      </v-avatar>
                      {{ itemeditpic.file_name }}
                    </v-chip>
                  </v-col>
                </v-row>

                <div id="snackbar" class="d-print-none">
                  <v-snackbar v-model="snackbar" color="success" right>
                    {{ text }}
                  </v-snackbar>
                </div>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="save"
              :disabled="!validannounce"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="newItem()"
          >Create New</v-btn
        >
      </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead style="background-color:#1976d2">
            <tr>
              <th class="text-center">
                <b style="color:white;">Title</b>
              </th>
              <th class="text-center"><b style="color:white">Status</b></th>
              <th class="text-center"><b style="color:white">Type</b></th>
              <th class="text-center"><b style="color:white">Important</b></th>

              <th class="text-center"><b style="color:white">Actions</b></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="items in data" :key="items.ticket_id">
              <td>{{ items.title }}<br />{{ items.subtitle }}</td>

              <td class="text-center">
                {{ items.status == 0 ? "Not Active" : "Active" }}
              </td>

              <td class="text-center">{{ items.type }}</td>
              <td class="text-center">
                {{
                  items.important == "L"
                    ? "Low"
                    : items.important == "M"
                    ? "Medium"
                    : items.important == "H"
                    ? "High"
                    : ""
                }}
              </td>
              <td class="text-center">
                <v-icon small class="mr-2" @click="editItem(items)"
                  >mdi-square-edit-outline</v-icon
                >
                <v-icon small @click="deleteItem(items)">mdi-delete</v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="text-center pb-5 pt-4">
        <div>
          <v-btn class="mx-2" fab small @click="back()">
            <v-icon dark small>mdi-chevron-left</v-icon>
          </v-btn>

          <v-btn
            class="mx-2"
            fab
            small
            :color="btn_color(n)"
            v-for="n in page_count"
            :key="n"
            @click="getpage(page_num_show(n))"
            >{{ page_num_show(n) }}</v-btn
          >

          <v-btn class="mx-2" fab small @click="next()">
            <v-icon dark small>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
      <!-- <v-data-table
        :headers="headers"
        :items="this.data"
        :items-per-page="10"
        :loading="isLoading"
        :search="search"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.title="{ item }">
          <span class="subtitle-1">{{ item.title }}</span>
          <br />
          <span class="body-2">{{ item.subtitle }}</span>
        </template>
        <template v-slot:item.status="{ item }">{{
          item.status == 0 ? "Not Active" : "Active"
        }}</template>
        <template v-slot:item.important="{ item }">
          {{
            item.important == "L"
              ? "Low"
              : item.important == "M"
              ? "Medium"
              : item.important == "H"
              ? "High"
              : ""
          }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"
            >mdi-square-edit-outline</v-icon
          >
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table> -->
    </v-card>

    <view-announce class="pt-10" />

    <div id="snackbar">
      <v-snackbar v-model="snackbar" color="success" right>
        {{ text }}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import ViewAnnounce from "../Project/components/ViewAnnounce";

export default {
  computed: {
    ...mapState(["isLoading"]),
    ...mapState(["snackbar"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Announce" : "Edit Announce";
    },
    computedDateFormatted1() {
      this.editItem.expireddate = this.formatDate(this.date1);
      return this.editItem.expireddate;
    },
  },
  components: {
    "view-announce": ViewAnnounce,
  },
  mounted() {
    //เปิดหน้านี้ครั้งแรก จะเข้ามาทำที่ mounted ก่อนเป็นอัมดับแรก
    this.getAjax(); // เรียกฟังชั้น getAjax
    this.getTeam();
  },
  data() {
    return {
      datapage: [],
      page_count: 0,
      page_total: 0,
      date1: new Date().toISOString().substr(0, 10),
      time1: null,
      timemenu1: false,
      datemenu1: false,
      date2: new Date().toISOString().substr(0, 10),
      time2: null,
      timemenu2: false,
      datemenu2: false,
      content: [],
      dialogcontent: false,
      validannounce: false,
      nottitle: [(v) => !!v || "title is required"],
      colors1: ["#fb8c00", "#fb8c00", "#fb8c00", "#fb8c00", "#fb8c00"],

      notimportant: [(v) => !!v || "important is required"],
      showpic: `${process.env.VUE_APP_ROOT_API}/api/announce/attachments/`,
      status: "",
      important: "",
      text: "Success, Log has been saved",
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],

      item1: [
        {
          name: "Low",
          id: "L",
        },
        {
          name: "Medium",
          id: "M",
        },
        {
          name: "High",
          id: "H",
        },
      ],

      no: 1,
      search: "",
      data: [],
      dialog: false,
      dialogimg: false,
      edit: [],
      editedIndex: -1,
      files: [],
      teamselected: [],
      typeselected: "",
      team: [],
      type: ["Announce", "Knowledge"],
      editedItem: {
        title: "",
        subtitle: "",
        expireddate: "",
        content: "",
        status: "",
        important: "",
        team: [],
        type: "",
        keyword: "",
      },
      defaultItem: {
        title: "",
        subtitle: "",
        expireddate: "",
        content: "",
        status: "",
        important: "",
        team: [],
        type: "",
        keyword: "",
      },
      url: process.env.VUE_APP_ROOT_API,
      // headers: [
      //   {
      //     text: "Title",
      //     value: "title",
      //     class: "text-uppercase blue darken-3 white--text",
      //   },
      //   {
      //     text: "Status",
      //     value: "status",
      //     class: "text-uppercase blue darken-3 white--text",
      //   },
      //   {
      //     text: "Type",
      //     value: "type",
      //     class: "text-uppercase blue darken-3 white--text",
      //   },
      //   {
      //     text: "Important",
      //     value: "important",
      //     class: "text-uppercase blue darken-3 white--text",
      //   },
      //   {
      //     text: "Actions",
      //     value: "action",
      //     class: "text-uppercase blue darken-3 white--text",
      //     sortable: false,
      //   },
      // ],
    };
  },
  methods: {
    async back() {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      let url = this.datapage.prev_page_url;
      let { data } = await axios.get(url, options);
      this.datapage = data;
      this.data = data.data;
    },
    async next() {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      let url = this.datapage.next_page_url;
      let { data } = await axios.get(url, options);
      this.datapage = data;
      this.data = data.data;
    },
    async getpage(num) {
      this.data = [];
      this.datapage = [];
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      if (num != "...") {
        this.current_page = num;
        let url = `${process.env.VUE_APP_ROOT_API}/api/announce?page=` + num;
        let { data } = await axios.get(url, options);

        this.datapage = data;
        this.data = data.data;
      }
    },
    btn_color(n) {
      if (this.page_count == 7) {
        if (this.datapage.current_page <= 4) {
          return this.datapage.current_page === n ? "primary" : "";
        } else if (this.datapage.current_page == this.datapage.last_page) {
          return n === 7 ? "primary" : "";
        } else if (this.datapage.current_page == this.datapage.last_page - 1) {
          return n === 6 ? "primary" : "";
        } else if (this.datapage.current_page == this.datapage.last_page - 2) {
          return n === 5 ? "primary" : "";
        } else {
          return n === 4 ? "primary" : "";
        }
      } else {
        return this.datapage.current_page === n ? "primary" : "";
      }
    },
    page_num_show(n) {
      let page = n;
      if (this.page_count == 7) {
        let chk2 = 0;
        let chk3 = 0;
        let chk4 = 0;
        let chk5 = 0;
        let chk6 = 0;
        if (this.datapage.current_page == 1) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.datapage.last_page - 1;
        } else if (this.datapage.current_page == this.datapage.last_page) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.datapage.last_page - 3;
          chk5 = this.datapage.last_page - 2;
          chk6 = this.datapage.last_page - 1;
        } else if (this.datapage.current_page == 2) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.datapage.last_page - 1;
        } else if (this.datapage.current_page == this.datapage.last_page - 1) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.datapage.last_page - 3;
          chk5 = this.datapage.last_page - 2;
          chk6 = this.datapage.last_page - 1;
        } else if (this.datapage.current_page == 3) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.datapage.last_page - 1;
        } else if (this.datapage.current_page == this.datapage.last_page - 2) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.datapage.last_page - 3;
          chk5 = this.datapage.last_page - 2;
          chk6 = this.datapage.last_page - 1;
        } else {
          chk2 = "...";
          chk3 = this.datapage.current_page - 1;
          chk4 = this.datapage.current_page;
          chk5 = this.datapage.current_page + 1;
          chk6 = "...";
        }

        n === 1 ? (page = 1) : "";
        n === 2 ? (page = chk2) : "";
        n === 3 ? (page = chk3) : "";
        n === 4 ? (page = chk4) : "";
        n === 5 ? (page = chk5) : "";
        n === 6 ? (page = chk6) : "";
        n === 7 ? (page = this.datapage.last_page) : "";
      } else {
        n === 1 ? (page = 1) : "";
        n === 2 ? (page = 2) : "";
        n === 3 ? (page = 3) : "";
        n === 4 ? (page = 4) : "";
        n === 5 ? (page = 5) : "";
        n === 6 ? (page = 6) : "";
      }
      return page;
    },
    ...mapMutations(["mutateIsLoading"]),
    ...mapMutations(["mutatesnackbar"]),
    remove(item) {
      this.editedItem.keyword.splice(this.editedItem.keyword.indexOf(item), 1);
      this.editedItem.keyword = [...this.editedItem.keyword];
    },
    formatDate(date1) {
      if (!date1) return null;
      const [year, month, day] = date1.split("-");
      return `${year}-${month}-${day}`;
    },
    substr(myarguments) {
      let filetype = myarguments.substr(-3);
      let arr = Array("jpeg", "png", "gif", "jpg");
      if (arr.indexOf(filetype) >= 0) {
        return true;
      }
      return false;
    },
    cancelcontent() {
      this.dialogcontent = false;
    },
    deletepic(pic, pic1, item) {
      this.$swal({
        title: "Are you sure you want to delete ?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((del) => {
        if (del) {
          if (this.deletepic1(pic, pic1, item)) {
            swal({
              title: "Delete Complete",
              icon: "success",
              button: "OK",
            });
            setTimeout(() => {
              this.showfile(this.edit.announce_id);
            }, 1000);
          }
        } else {
        }
      });
    },
    async deletepic1(pic, pic1, item) {
      const idx = pic;
      const url = `${process.env.VUE_APP_ROOT_API}/api/announce/attachments`;
      try {
        const { data } = await axios.delete(url + "/" + idx);
      } catch (error) {
        console.log(error);
      }

      // this.getAjax();

      // this.dialog = false;
      // console.log(this.dialog);
      // this.editItem(pic1);
    },
    showcontent(a) {
      this.dialogcontent = true;

      this.showdata(a);
    },
    async showdata(id) {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/announce/` + id;
      try {
        this.mutateIsLoading();
        const { data } = await axios.get(url, options);

        this.editedItem = data;
        if (this.editedItem.status == 0) {
          this.editedItem.status = false;
        }
        this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    },
    showimg() {
      this.dialogimg = true;
    },
    cancelimg() {
      this.dialogimg = false;
    },
    resetEdited() {
      this.editedItem = this.defaultItem;
      this.editedIndex = -1;
    },
    newItem() {
      this.resetEdited();
      this.editedItem.type = "Announce";
      this.teamselected = [];
      this.editedItem.title = "";
      this.editedItem.subtitle = "";
      this.editedItem.important = "";
      this.editedItem.status = "";
      this.editedItem.content = "";
      this.editedItem.keyword = "";
      this.editedItem.files = [];
      this.edit.files = [];
      this.edit.images = [];
      this.dialog = true;
    },
    editItem(item) {
      // console.log(item, "showitemhererer");
      // this.teamselected = item.team.map(each => {
      //   return each.team_id;
      // });
      this.editedIndex = item.announce_id;
      // item.status = item.status == 1 ? 1 : 0;
      this.showdata(item.announce_id);
      // this.editedItem = Object.assign({}, item);
      this.date1 = item.expired_date;
      this.showfile(item.announce_id);
      this.dialog = true;
    },
    async deleteItem(item) {
      const idx = item.announce_id;

      if (confirm("Are you sure you want to delete this Announce?")) {
        const url = `${process.env.VUE_APP_ROOT_API}/api/announce`;
        try {
          const { data } = await axios.delete(url + "/" + idx);
        } catch (error) {
          console.log(error);
        }
        this.getAjax();
      }
    },
    close() {
      this.dialog = false;
      this.resetEdited();
    },
    save() {
      this.mutatesnackbar();
      this.editedItem.team = this.teamselected;
      this.editedItem.status = this.editedItem.status == true ? 1 : 0;
      this.sendAjax(this.editedItem, this.editedIndex);
      this.close();
      if (this.snackbar === true) {
        setTimeout(() => {
          this.mutatesnackbar();
          this.snackbar;
        }, 2000);
      }
    },

    async sendAjax(item, idx) {
      const url = `${process.env.VUE_APP_ROOT_API}/api/announce`;
      // console.log(item.status);
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "multipart/form-data",
        },
      };
      if (idx > -1) {
        try {
          let formData = new FormData();
          if (item.type == "Knowledge") {
            formData.append("type", item.type);
            formData.append("title", item.title);
            formData.append("status", item.status);
            formData.append("team", "");
            formData.append("important", "");
            formData.append("expired_date", "");
            formData.append("keyword", item.keyword);
            formData.append("subtitle", item.subtitle);
            formData.append("content", item.content);
          } else if (item.type == "Announce") {
            formData.append("type", item.type);
            formData.append("title", item.title);
            formData.append("status", item.status);
            formData.append("team", item.team);
            formData.append("important", item.important);
            formData.append("expired_date", this.date1);
            formData.append("keyword", "");
            formData.append("subtitle", item.subtitle);
            formData.append("content", item.content);
          }

          if (undefined !== item.files && item.files.length) {
            for (let i = 0; i < item.files.length; i++) {
              formData.append(`files[${i}]`, item.files[i]);
            }
          }
          const { data } = await axios.post(
            url + "/" + this.editedIndex,
            formData
          );
          // console.log(this.data);
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          let formData = new FormData();
          // console.log(item.type, "type");
          if (item.type == "Knowledge") {
            formData.append("type", item.type);
            formData.append("title", item.title);
            formData.append("status", item.status);
            formData.append("team", "");
            formData.append("important", "");
            formData.append("expired_date", "");
            formData.append("keyword", item.keyword);
            formData.append("subtitle", item.subtitle);
            formData.append("content", item.content);
          } else if (item.type == "Announce") {
            formData.append("type", item.type);
            formData.append("title", item.title);
            formData.append("status", item.status);
            formData.append("team", item.team);
            formData.append("important", item.important);
            formData.append("expired_date", this.computedDateFormatted1);
            formData.append("keyword", "");
            formData.append("subtitle", item.subtitle);
            formData.append("content", item.content);
          }

          if (undefined !== item.files && item.files.length) {
            for (let i = 0; i < item.files.length; i++) {
              formData.append(`files[${i}]`, item.files[i]);
            }
          }
          const { data } = await axios.post(url, formData, options);
        } catch (error) {
          console.log(error);
        }
      }
      this.getAjax();
    },

    async getAjax() {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/announce`;
      try {
        this.mutateIsLoading();
        const { data } = await axios.get(url, options);
        this.data = data.data;
        this.datapage = data;
        this.page_total = data.last_page;
        this.page_total < 7
          ? (this.page_count = this.page_total)
          : (this.page_count = 7);
        this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    },
    onFileSelected(event) {
      this.editedItem.files = Array();
      for (let i = 0; i < event.length; i++) {
        this.editedItem.files.push(event[i]);
      }
    },
    async showfile(id) {
      const url = `${process.env.VUE_APP_ROOT_API}/api/announce/` + id;
      // console.log(url);
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      try {
        this.mutateIsLoading();
        const { data } = await axios.get(url, options);
        this.edit = data;
        this.teamselected = [...this.edit.team];
        this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    },
    async getTeam() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/announce/get-team`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      try {
        this.mutateIsLoading();
        const { data } = await axios.get(url, options);
        // console.log(data, "ttt");
        this.team = data;
        this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.image {
  display: none;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
